import { render, staticRenderFns } from "./ModalLog.vue?vue&type=template&id=78c0ffb7&"
import script from "./ModalLog.vue?vue&type=script&lang=js&"
export * from "./ModalLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports